import ExternallyAcquiredAchievement from 'models/achievement/ExternallyAcquiredAchievement';

import AchievementBaseService from 'services/achievement/AchievementBaseService';

export default class ExternallyAcquiredAchievementService extends AchievementBaseService {
	toModel(achievement) {
		return new ExternallyAcquiredAchievement(achievement);
	}
}
